import { BaseFragmentController } from 'src/app/View/BaseUI/BaseFragmentController';
import { PcrInterviewFragmentComponent } from './PcrInterviewFragmentComponent';
import { PcrService } from '../../../../../Service/PcrService';
import {StorageService} from '../../../../../Service/StorageService';
import {AppSingletonUtil} from '../../../../../Util/AppSingletonUtil';
import {UserService} from '../../../../../Service/UserService';

/**
 * PcrInterviewFragmentController
 * 問診画面のコントローラー
 */
export class PcrInterviewFragmentController extends BaseFragmentController {

	// 対となるView
	public combineView: PcrInterviewFragmentComponent;


	// 問診票を取得する
	public async getPcrInterviewMstList(param: { view: any }) {

		const svc = new PcrService(param.view);
		return await svc.getPcrInterviewMstList();

	}


	// 問診表を登録する
	public async savePcrInterview(param: { view: any; data: any; specimenNum: number; pcrExamineRemark: string }) {

		const svc = new PcrService(param.view);
		return await svc.savePcrInterview(param.data, param.specimenNum, param.pcrExamineRemark);

	}

	/**
	 * ログイン済みでトークンを設定しているかどうか
	 * @returns true: トークン・ユーザー情報あり/false: トークン無し or ユーザー情報無し
	 */
	public async isExistToken(view: any) {

		// ストレージにトークンがあるかチェック
		const svc = new StorageService(this);
		const isExist = await svc.isItemExist('t');

		// トークンが存在しなければログアウト
		if (!isExist) {
			return false;
		}
		// トークンを取得
		const token = await svc.getItem('t');
		if (!token) {
			// トークンの値が存在しない場合
			await svc.clear();
			return false;
		}
		AppSingletonUtil.setToken(token);

		// ユーザー情報を取得
		// トークンでユーザー情報が取得できるかどうか
		const userSvc = new UserService(view);
		const user = await userSvc.getUserInfo();
		if (!user) {
			// ユーザー情報取れない場合は終了
			await svc.clear();
			return false;
		}
		AppSingletonUtil.setUserInfo(user);

		return true;
	}

	/**
	 * checkInputData
	 * 入力チェック
	 * @param formData 入力データ(共通項目)
	 */
	public checkInputData(formData: any): Array<string> {
		const msg = Array<string>();

		// 必須項目チェック
		if (!formData.type || formData.type < 1) {
			msg.push('検査種類が選択されていません。');
		}
		if (!formData.group || formData.group < 1) {
			msg.push('検査枠が選択されていません。');
		}
		if (!formData.cert || formData.cert < 1) {
			msg.push('陰性証明書が選択されていません。');
		}
		if (formData.cert === 2 || formData.cert === 4) {
			if (!formData.name || formData.name < 1) {
				msg.push('「氏名（英語）　Name」が入力されていません。');
			}
			if (!formData.passportNo || formData.passportNo < 1) {
				msg.push('「パスポート番号　PassportNo」が入力されていません。');
			}
			if (!formData.nationality || formData.nationality < 1) {
				msg.push('「国籍　Nationality」が選択されていません。');
			}
		}
		if (!formData.positiveCert || formData.positiveCert < 1) {
			msg.push('陽性証明書が選択されていません。');
		}

		return msg;
	}

	/**
	 * ストレージにリファラとしてpcrformをセットする
	 * @param view
	 */
	public async setReferrer(view: any): Promise<any> {
		const svc = new StorageService(this);
		const ret = svc.saveItem('referrer', 'pcrform');

		if (!ret) {
			return false;
		}

		return true;
	}
}
